import {
  FETCH_ACCOUNT,
  FETCH_ACCOUNT_STARTED,
  FETCH_ACCOUNT_SUCCEEDED,
  FETCH_ACCOUNT_FAILED,
  FETCH_ACCOUNT_FAILED_UNAUTHORIZED,
  PATCH_ACCOUNT_TIME_ZONE
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  requestStatus: statuses.idle
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_STARTED:
      return { ...state, requestStatus: statuses.loading };
    case FETCH_ACCOUNT:
    case FETCH_ACCOUNT_SUCCEEDED:
      return { ...action.payload, requestStatus: statuses.succeeded };
    case FETCH_ACCOUNT_FAILED: {
      return { ...state, requestStatus: statuses.failed };
    }
    case FETCH_ACCOUNT_FAILED_UNAUTHORIZED:
      return { ...state, requestStatus: statuses.failed, logout: true };
    case PATCH_ACCOUNT_TIME_ZONE:
      return { ...state, timeZone: action.payload };
    default:
      return state;
  }
};
